(() => {
  if (customElements.get('pnp-purchase-summary')) return;
  class PnpPurchaseSummary extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      try { this.config = JSON.parse(this.querySelector('[data-purchase-config]').textContent); }
      catch (_) { return; }
      this.scope = this.closest('.product__info-container') || this.closest('.shopify-section') || this.parentElement;
      this.optionsNode = this.querySelector('[data-purchase-options]');
      this.priceNode = this.querySelector('[data-purchase-price]');
      this.priceWrap = this.querySelector('[data-purchase-price-wrap]');
      this.discountLabel = this.querySelector('[data-purchase-discount-label]');
      this.unavailableNode = this.querySelector('[data-purchase-unavailable]');
      this.stockNode = this.querySelector('[data-purchase-stock]');
      this.initialized = true;
      this.bfActive = !!window.PnpBfCampaign?.active;
      this.onBfState = event => {
        this.bfActive = !!event.detail?.active;
        this.scheduleUpdate();
      };
      document.addEventListener('pnp:bf-state', this.onBfState);
      this.onChange = () => this.scheduleUpdate();
      this.scope.addEventListener('change', this.onChange);
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.scheduleUpdate();
      });
      this.observer.observe(this.scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'checked'] });
      this.update();
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('change', this.onChange);
      document.removeEventListener('pnp:bf-state', this.onBfState);
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
      this.initialized = false;
    }
    scheduleUpdate() {
      if (this.frame || !this.initialized) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        if (this.initialized) this.update();
      });
    }
    selectedVariant() {
      const picker = this.scope.querySelector('variant-radios, variant-selects');
      if (picker && !this.config.hasOnlyDefaultVariant) {
        let groups = Array.from(picker.querySelectorAll('.product-form__input'));
        if (!groups.length) groups = Array.from(picker.querySelectorAll('fieldset, select')).filter(group => group.tagName === 'FIELDSET' || !group.closest('fieldset'));
        const options = groups.map(group => {
          if (group.tagName === 'SELECT') return group.value;
          const select = group.querySelector('select');
          return select ? select.value : group.querySelector('input[type="radio"]:checked')?.value;
        });
        if (options.length === this.config.variants[0]?.options.length) {
          return this.config.variants.find(variant => variant.options.every((option, index) => String(option) === String(options[index]))) || null;
        }
      }
      const id = this.scope.querySelector('form[action*="/cart/add"] [name="id"]')?.value || this.config.initialId;
      return this.config.variants.find(variant => String(variant.id) === String(id)) || null;
    }
    update() {
      const variant = this.selectedVariant();
      const showBfPrice = this.bfActive && this.config.bfEligible && !!variant;
      this.unavailableNode.hidden = !!variant;
      this.priceWrap.hidden = !variant || !showBfPrice && (this.config.compact || this.config.hasOnlyDefaultVariant);
      if (this.discountLabel) this.discountLabel.hidden = !showBfPrice;
      this.dataset.pnpBfActive = String(showBfPrice);
      this.optionsNode.hidden = !variant || !variant.selection;
      const selection = variant?.selection || '';
      const price = (showBfPrice ? variant?.salePrice : variant?.price) || '';
      if (this.optionsNode.textContent !== selection) this.optionsNode.textContent = selection;
      if (this.priceNode.textContent !== price) this.priceNode.textContent = price;
      const available = !!variant?.available;
      const stock = available ? this.config.strings.inStock + ' · ' + this.config.strings.nextDay : this.config.strings.unavailable;
      if (this.stockNode.textContent !== stock) this.stockNode.textContent = stock;
      this.dataset.state = !variant ? 'unavailable' : variant.available ? 'available' : 'sold-out';
    }
  }
  customElements.define('pnp-purchase-summary', PnpPurchaseSummary);
})();



